import SortTriangleDownIcon from '/public/icons/sort-triangle-down.svg';
import SortTriangleUpIcon from '/public/icons/sort-triangle-up.svg';
import SortTriangleIcon from '/public/icons/sort-triangle.svg';

interface SortTriangleIndicatorProps {
  direction: 'asc' | 'desc' | false;
}

export const SortTriangleIndicator = ({ direction }: SortTriangleIndicatorProps) => {
  return (
    <span className="relative inline-block w-3.5 h-3.5 leading-none align-middle">
      <SortTriangleIcon className="block" />
      {direction === 'asc' && <SortTriangleUpIcon className="block absolute inset-0 text-blue-300" />}
      {direction === 'desc' && <SortTriangleDownIcon className="block absolute inset-0 text-blue-300" />}
    </span>
  );
};
